import { render, staticRenderFns } from "./TheDashboardLayout.vue?vue&type=template&id=3c51bcf1&"
import script from "./TheDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./TheDashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c51bcf1')) {
      api.createRecord('3c51bcf1', component.options)
    } else {
      api.reload('3c51bcf1', component.options)
    }
    module.hot.accept("./TheDashboardLayout.vue?vue&type=template&id=3c51bcf1&", function () {
      api.rerender('3c51bcf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/Admin/TheDashboardLayout.vue"
export default component.exports